<template>
  <v-dialog
  persistent
  v-model="showEdit"
  max-width="400px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Edit repeat job</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn fab flat medium @click="$emit('update:showEdit', false)">
              <v-icon >close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row v-if="error">
          <v-flex xs12 sm6 offset-sm3>
            <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
          </v-flex>
        </v-layout>
        <form @submit.prevent="onUpdateRepeatJob">
        <v-layout column pt-2>
          <v-flex >
              <v-combobox
                v-model="client_nameFormatted"
                label="Client"
                :items="clients"
                item-text="name"
                item-value="name"
                hide-details
                dense
                placeholder="Choose or add a client"
                @input="saveClientName()"
                :autofocus="!$vuetify.breakpoint.xsOnly"
                ref="clientname"
              ></v-combobox>
              <line-items
                :lineItems="lineItemJob.lineItems"
                :newLineItemKey="newLineItemKey"
                :itemAmount="lineItemJob.amount"
                :itemTotalTaxPortion="lineItemJob.totalTaxPortion"
                :itemTotalNetAmount="lineItemJob.totalNetAmount"
                :itemTitle="lineItemJob.title"
                :itemTaxIncluded="lineItemJob.taxIncluded"
                @create-new-key="getLineItemKey"
                @line-items-output="updateJobFromLineItems"
              />
              <v-radio-group v-model="schedule.frequency" class="pt-0 mt-3">
                <v-radio color="primary"  label="Monthly" value="monthly"></v-radio>
                <v-radio color="primary"  label="Yearly" value="yearly"></v-radio>
              </v-radio-group>
              <v-select
              v-model="schedule.dayOfMonth"
              label="on day of month"
              :items="dayRange"
              dense
              ></v-select>
              <transition name="fade">
                <v-select
                v-show="schedule.frequency === 'yearly'"
                v-model="schedule.monthOfYear"
                label="Month of year"
                :items="monthRange"
                item-text="month"
                item-value="number"
                dense
                >
                </v-select>
              </transition>
          </v-flex>
        </v-layout>
        <v-layout pt-0 align-end justify-start row fill-height>
          <v-btn style="margin-left:0; margin-right:0;" color="primary" large depressed type="submit" :disabled="loading" :loading="loading">
              Save
              <span slot="loader" class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="error" flat large @click.stop="deleteRepeatJob()" :disabled="loading" :loading="loading">
              Delete
              <span slot="loader" class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
        </v-layout>
        </form>
      </v-container>
    </v-card>
    <confirm ref="confirm"></confirm>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'
import firebase from 'firebase/app'
import 'firebase/database'
import { calculateRepeatDateFromSchedule } from '@/components/Mixins/calculateRepeatDateFromSchedule'
import Confirm from '@/components/Shared/Confirm'
import LineItems from '@/components/Shared/LineItems'

export default {
  name: 'EditRepeatJobModal',
  mixins: [
    calculateRepeatDateFromSchedule,
    formatDate
  ],
  components: {
    Confirm,
    LineItems
  },
  props: {
    showEdit: Boolean,
    editingRepeatJob: Object
  },
  data () {
    return {
      id: '',
      title: '',
      clientName: '',
      amount: '0.00',
      totalTaxPortion: 0,
      totalNetAmount: 0,
      taxIncluded: this.$store.getters.group.taxCalcInclusive,
      lineItems: {},
      schedule: {
        frequency: 'monthly',
        dayOfMonth: new Date().getDate(),
        monthOfYear: new Date().getMonth(),
        lastCreated: 'never'
      },
      nextRepeats: '',
      zuluRepeats: '',
      client_nameFormatted: '',
      clients: this.$store.getters.clients,
      grouptz: this.$store.getters.group.tz,
      dayRange: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      monthRange: [
        { month: 'January', number: 0 },
        { month: 'February', number: 1 },
        { month: 'March', number: 2 },
        { month: 'April', number: 3 },
        { month: 'May', number: 4 },
        { month: 'June', number: 5 },
        { month: 'July', number: 6 },
        { month: 'August', number: 7 },
        { month: 'September', number: 8 },
        { month: 'October', number: 9 },
        { month: 'November', number: 10 },
        { month: 'December', number: 11 }
      ],
      currSymbol: this.$store.getters.group.currSymbol,
      newLineItemKey: ''
    }
  },
  watch: {
    showEdit (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.clientname.focus()
      })
      this.getLineItemKey()
    },
    editingRepeatJob: {
      handler: function () {
        if (this.editingRepeatJob !== '') {
          this.id = this.editingRepeatJob.id
          this.title = this.editingRepeatJob.title
          this.clientName = this.editingRepeatJob.clientName
          this.client_nameFormatted = this.editingRepeatJob.clientName
          this.amount = this.editingRepeatJob.amount
          this.totalTaxPortion = this.editingRepeatJob.totalTaxPortion
          this.totalNetAmount = this.editingRepeatJob.totalNetAmount
          this.title = this.editingRepeatJob.title
          this.taxIncluded = this.editingRepeatJob.taxIncluded
          this.lineItems = this.editingRepeatJob.lineItems
          this.schedule = this.editingRepeatJob.schedule
          this.nextRepeats = this.editingRepeatJob.nextRepeats
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    },
    lineItemJob () {
      return this.editingRepeatJob
    }
  },
  methods: {
    updateJobFromLineItems (payload) {
      // update the repeat job with the lineitems output
      this.amount = payload.amount
      this.totalTaxPortion = payload.totalTaxPortion
      this.totalNetAmount = payload.totalNetAmount
      this.title = payload.title
      this.taxIncluded = payload.taxIncluded
      this.lineItems = payload.lineItems
    },
    getLineItemKey () {
      const listId = 3
      const jobId = this.id
      const groupId = this.user.group
      const ref = firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/lineItems').push().key
      this.newLineItemKey = ref
    },
    onUpdateRepeatJob () {
      this.$refs.clientname.blur()
      this.$nextTick(() => {
        this.$store.dispatch('clearError')
        if (this.clientName === '' || this.clientName === null) {
          this.$store.commit('setError', { message: 'Please enter a name for the client' })
          return
        }
        const newSchedule = {
          frequency: this.schedule.frequency,
          dayOfMonth: this.schedule.dayOfMonth,
          monthOfYear: this.schedule.monthOfYear,
          lastCreated: this.schedule.lastCreated,
          tz: this.grouptz
        }
        const repeatTime = this.calculateRepeatDateFromSchedule(newSchedule)
        const newJob = {
          id: this.id,
          title: this.title,
          clientName: this.clientName,
          amount: this.amount,
          totalTaxPortion: this.totalTaxPortion,
          totalNetAmount: this.totalNetAmount,
          taxIncluded: this.taxIncluded,
          lineItems: this.lineItems,
          schedule: newSchedule,
          // store this as a nice simple string for display only
          nextRepeats: this.formatDate(repeatTime),
          // store the actual zulu time (UTC +0.00) that the server be using
          // we'll use this with the cronjobs to work out exactly when to fire a new job off
          // eg. 25 Feb 19 in East Kazakhstan Time is "2019-02-24T18:00:00.000Z" ie 6 hours ahead
          // the cron run at 6pm on the 24th uk time will create this job at midnight kazakh time
          zuluRepeats: this.getUTCRepeatDateFromTimeZonedRepeatDate(repeatTime, this.grouptz)
        }

        this.$store.dispatch('onUpdateRepeatJob', newJob)
          .then(() => {
            this.$emit('updateJobList')
            this.$emit('update:showEdit', false)
          })
          .then(() => {
            this.id = ''
            this.title = ''
            this.clientName = ''
            this.client_nameFormatted = ''
            this.amount = ''
            this.totalTaxPortion = 0.00
            this.totalNetAmount = 0.00
            this.title = 'Untitled Job'
            this.taxIncluded = this.$store.getters.group.taxCalcInclusive
            this.lineItems = {}
            this.schedule = {
              frequency: 'monthly',
              dayOfMonth: new Date().getDate(),
              monthOfYear: new Date().getMonth(),
              lastCreated: 'never'
            }
            this.nextRepeats = ''
          })
      })
    },
    saveClientName () {
      // vuetify v-select returns object in item-value possible bug but to deal with this
      // we check for the name within the object if blank then it's a new typed in client
      // so we just use the string
      if (this.client_nameFormatted !== null && this.client_nameFormatted !== '') {
        // if it's a string...
        if (typeof this.client_nameFormatted === 'string') {
          // .. use the straight string variable and save the job
          this.clientName = this.client_nameFormatted
        } else {
          // else it's an object from the select so grab the name value from it
          this.clientName = this.client_nameFormatted.name
        }
      }
      const currentClientName = this.clientName
      if (this.clientName === '' || this.clientName === null) {
        return
      }
      if (this.clients.filter(function (client) { return client.name === currentClientName }).length > 0) {
      } else if (currentClientName !== '') {
        this.$store.dispatch('createClient', {
          name: this.clientName
        })
      }
    },
    async deleteRepeatJob () {
      if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
        await this.$store.dispatch('deleteRepeatJob', this.id)
        this.$emit('updateJobList')
        this.$emit('update:showEdit')
        this.id = ''
        this.title = ''
        this.clientName = ''
        this.client_nameFormatted = ''
        this.amount = ''
        this.schedule = {
          frequency: 'monthly',
          dayOfMonth: new Date().getDate(),
          monthOfYear: new Date().getMonth(),
          lastCreated: 'never'
        }
        this.nextRepeats = ''
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
